var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import config from '../services/config';
export var inmates = function inmates(siteApi, centralApi, getAuthToken) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = null;
      }
      return siteApi.get('/inmate', {
        params: __assign(__assign({}, params), {
          preferCache: false
        })
      });
    },
    indexCentral: function indexCentral(params) {
      if (params === void 0) {
        params = null;
      }
      return centralApi.get('/inmate', {
        params: __assign({}, params)
      });
    },
    get: function get(id, params) {
      return siteApi.get("/inmate/".concat(id), {
        params: params
      });
    },
    post: function post(data) {
      return siteApi.post('/inmate', data);
    },
    put: function put(id, changes) {
      return siteApi.put("/inmate/".concat(id), changes);
    },
    delete: function _delete(id, amount, note) {
      return siteApi.delete("/inmate/".concat(id), {
        data: {
          amount: amount,
          note: note
        }
      });
    },
    photoUrl: function photoUrl(id) {
      return "".concat(config.api.url, "/inmate/photo/").concat(id, "?token=").concat(getAuthToken().accessToken, "&r=").concat(new Date());
    },
    pin: function pin() {
      return siteApi.get('/inmate/pin');
    },
    postMerge: function postMerge(fromInmateId, toInmateId) {
      return centralApi.post('/inmate/merge', {
        fromInmateId: fromInmateId,
        toInmateId: toInmateId
      });
    }
  };
};